import { Navigate, createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/app/AppLayout";
import { ProtectedRoute } from "@/features/auth/ProtectedRoute";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { SettingsPage } from "@/features/settings/SettingsPage";
import { ImportantDatesPage } from "@/features/settings/important-dates/ImportantDatesPage";
import { UserManagementPage } from "@/features/settings/user-management/UserManagementPage";
import { LoginPage } from "@/app/routes/LoginPage";
import { GRCDashboardPage } from "@/features/grc/GRCDashboardPage";
import { DraftCalendarPage } from "@/features/draft-calendar/DraftCalendarPage";
import { MessageMonitorPage } from "@/features/message-monitor/MessageMonitorPage";

export const appRouter = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />
      },
      {
        path: "dashboard",
        element: <DashboardPage />
      },
      {
        path: "grcdashboard",
        element: <GRCDashboardPage />
      },
      {
        path: "draftcalendar",
        element: <DraftCalendarPage />
      },
      {
        path: "settings",
        element: <SettingsPage />,
        children: [
          {
            index: true,
            element: <Navigate to="important-dates" replace />
          },
          {
            path: "important-dates",
            element: <ImportantDatesPage />
          },
          {
            path: "user-management",
            element: <UserManagementPage />
          }
        ]
      },
      {
        path: "message-monitor",
        element: <MessageMonitorPage />
      }
    ]
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);
